import styled from 'styled-components';
import ListSubheader from '@material-ui/core/ListSubheader';

const AppMenuListSubheader = styled(ListSubheader)`
  && {
    padding-top: ${props => props.theme.spacing(2)}px;
    padding-bottom: ${props => props.theme.spacing(2)}px;
    text-transform: uppercase;
    color: #525257;
    font-size: 12px;
    line-height: 1;
  }
`;

export default AppMenuListSubheader;
